import { render, staticRenderFns } from "./orgExamInfo.vue?vue&type=template&id=b1b9a284&scoped=true&"
import script from "./orgExamInfo.vue?vue&type=script&lang=js&"
export * from "./orgExamInfo.vue?vue&type=script&lang=js&"
import style0 from "./orgExamInfo.vue?vue&type=style&index=0&id=b1b9a284&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1b9a284",
  null
  
)

export default component.exports